import { APISettings } from "../../config/ApiSettings";
import { BaseAPI } from "./baseApi";

const baseUrl = new APISettings().getApiURL();

class DocketApi extends BaseAPI {
  public getDocket: () => Promise<any> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/Docket`)).data;
  };

  public getDocketDetail: (filingId: number) => Promise<any> = async (filingId: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/Docket/${filingId}/detail`)).data;
  };

  public docketNotify: (filingId: number) => Promise<any> = async (filingId: number) => {
    return (await BaseAPI.axios.post(`${baseUrl}/Docket/${filingId}/notify`)).data.output;
  };

  public docketPublish: (filingId: number) => Promise<any> = async (filingId: number) => {
    return (await BaseAPI.axios.post(`${baseUrl}/Docket/${filingId}/publish`)).data.output;
  };
}

export const docketApi = new DocketApi();